import { render } from "./nationality.vue?vue&type=template&id=d12b4636"
import script from "./nationality.vue?vue&type=script&lang=js"
export * from "./nationality.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__